export default "__VITE_PUBLIC_ASSET__0f2163b7__"